import KendoDataSourceBase from '../KendoDataSourceBase'
import TreeListDataSourceProps from './TreeListDataSourceProps'

import Schema from './Schema'

export default {
    props: TreeListDataSourceProps,
    mixins: [
        KendoDataSourceBase, 
        Schema
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.TreeListDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.dataTreeListDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/KendoTreeListDataSourceMixin.js